export default {"src":"/_next/static/media/reach_logo_rgb_purple.5e5724dd.svg","height":66,"width":296,"blurWidth":0,"blurHeight":0};